import { render, staticRenderFns } from "./RoleListing.vue?vue&type=template&id=22467eb6"
import script from "./RoleListing.vue?vue&type=script&lang=js"
export * from "./RoleListing.vue?vue&type=script&lang=js"
import style0 from "./RoleListing.vue?vue&type=style&index=0&id=22467eb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports